import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ForecastElementAdjustmentComponent } from './forecast-element-adjustment.component';

const routes: Routes = [{ path: '', component: ForecastElementAdjustmentComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ForecastElementAdjustmentRoutingModule { }
